// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f0fad282","453":"1410d750"}[chunkId] + ".chunk.js";
};